import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Info, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Inventory } from 'models/InventoryModel';
import AsyncSelect from 'react-select/async';
import { ExamField as EMF } from 'constants/codes';
import { CommonDataColumn } from 'models/BaseModel';
import { getLabel } from 'helpers/forms/ExamHelper';
import { Exam } from 'models/ExamModel';
import { useSearchParams } from 'react-router-dom';
import { SaleItem } from 'models/SaleItemModel';
import { InventoryColumn } from 'constants/codes';
import { Product } from 'models/ProductModel';

const SaleItemForm: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.SALEITEM, Code.Form.Name.SALEITEM];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [noneLoading, setNoneLoading] = useState<boolean>(true);
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [controlOptions, setControlOptions] = Hooks.Form.OptionMore();
  const [formData, setFormData] = useState<SaleItem>({});
  const [inventoryData, setInventoryData] = useState<CommonDataColumn>({});
  const [typeOptions, setTypeOptions] = Hooks.Form.Options();
  const [isExam, setIsExam] = useState<boolean>(false);
  const [isCLens, setCLens] = useState<boolean>(false);
  const [isSpec, setIsSpec] = useState<boolean>(false);
  const [isSKUDisable, setIsSKUDisable] = useState<boolean>(false);
  const [specTitle, setSpecTitle] = useState<string>('');
  const [examOptions, setExamOptions] = Hooks.Form.Options();
  const [allOptions, setAllOptions] = Hooks.Form.Options();
  const [examList, setExamList] = useState<Exam[]>([]);
  const [results, setResults] = useState<Inventory[]>([]);
  const [searchKey, setSearchKey] = useState('');
  
  const [showImportExam, setShowImportExam] = useState<boolean>(false);
  const [isImportExam, setIsImportExam] = useState<boolean>(false);
  const [isExamType, setIsExamType] = useState<number>(0);
  const [examListOptions, setExamListOptions] = Hooks.Form.Options();
  const [typeListOptions, setTypeListOptions] = Hooks.Form.Options();
  const [examId, setExamId] = useState<string | number | null | undefined>(undefined);
  const [typeId, setTypeId] = useState<string | number | null | undefined>(undefined);

  const [lensTypeList, setLensTypeList] = useState<string>("");
  const [tintedList, setTintedList] = useState<string>("");
  const [sphereList, setSphereList] = useState<string>("");
  const [cylinderList, setCylinderList] = useState<string>("");
  const [prismList, setPrismList] = useState<string>("");
  const [orientList, setOrientList] = useState<string>("");
  const [acuityList, setAcuityList] = useState<string>("");
  const [axisList, setAxisList] = useState<string>("");
  const [addList, setAddList] = useState<string>("");

  const [contactLensFittingStatus, setContactLensFittingStatus] = useState<string>("");
  const [contactLensSupplier, setContactLensSupplier] = useState<string>("");
  const [contactLensType, setContactLensType] = useState<string>("");
  const [contactLensName, setContactLensName] = useState<string>("");
  const [contactLensColour, setContactLensColour] = useState<string>("");
  const [contactLensSolution, setContactLensSolution] = useState<string>("");

  const [searchParams] = useSearchParams();
  const clientId = searchParams.get(Code.UrlPara.Client);
  const saleId = searchParams.get(Code.UrlPara.Sale);
  const saleOrderId = searchParams.get(Code.UrlPara.SaleOrder);
  const productId = searchParams.get(Code.UrlPara.Product);

  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    Files.Json.Http(Code.File.SALEITEMTYPE, Code.Option.Common.SELECT, setTypeOptions, setError);

    API.Data.GetByKeyId<SaleItem>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.saleitem_active); 
        Files.List.ParseCommonData(data.saleitem_data, setInventoryData);
        const productName = await API.Data.GetProductName(data.product_id);
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
          product_name: Utility.Value.Text(productName), 
        }));
        setLoading(false);
      }})

      const onNewEntry = async () => {
        if(keyId===Code.Key.NEW) {
          
          setFormData((prevData) => ({
            ...prevData,
            sale_id: Number(saleId),
            saleorder_id: Number(saleOrderId),
            saleitem_quantity: 1
          }));

          if(productId){
            const productName = await API.Data.GetProductName(Number(productId));
            setFormData((prevData) => ({
            ...prevData,
            product_id: Number(productId) || 2,
            product_name: Utility.Value.Text(productName), 
            saleitem_quantity: 1
          }));
          }

        }
        setLoading(false);
      };
      onNewEntry();

  }, []);

  useEffect(() => {
    console.clear();
    //console.log("formData----------->",formData);
  }, [formData]);

  //check item datatype, and filter the fields
  useEffect(()=>{
    const specificationId = Number(formData.specification_id ?? 0);

    //console.log("------>",specificationId);

    if(specificationId >=100){
      
      if(specificationId){  
        setIsExam(false); setCLens(false); setIsSpec(false);setShowImportExam(false); setIsExamType(0); setIsImportExam(false);
        setSpecTitle(Code.Option.ControlTitle[specificationId] || '');
        if(specificationId == Number(Code.Option.Control.EXAM)) {
          setIsExam(true);
          setShowImportExam(true);
          setIsExamType(specificationId);
          Files.Json.Http(Code.File.EXAM+Code.File.OPTION, Code.Option.Common.NOTHING, setExamOptions, setError,);
          setFormData((prevData) => ({
            ...prevData,
            type_id: 21, 
          }));
          setIsSKUDisable(true);
        }
        else if(specificationId == Number(Code.Option.Control.CONTACTLENS)) {
          setCLens(true);
          setShowImportExam(true);
          setIsExamType(specificationId);
          Files.Json.API(Code.File.OPTION+Code.File.ALL, Code.Option.Common.NOTHING, setAllOptions, setError,);
          setFormData((prevData) => ({
            ...prevData,
            type_id: 21, 
          }));
          setIsSKUDisable(true);
        }
        else { 
          setIsSpec(true); 
          Files.Json.APIMore(Code.File.CONTROL+specificationId, Code.Option.Common.NOTHING, setControlOptions, setError); 
          if(specificationId == Code.Option.Control.LENS){
            setFormData((prevData) => ({
              ...prevData,
              type_id: 21, 
            }));
            setIsSKUDisable(true);
          }
          
        }
      } 
    }
  },[formData.specification_id])

  //suggested values for exam fields
  useEffect(() => {
    if (examOptions.length > 0) {
      setLensTypeList(getLabel(Code.Exam.Option.LENSTYPE, examOptions));
      setTintedList(getLabel(Code.Exam.Option.TINTED, examOptions));
      setSphereList(getLabel(Code.Exam.Option.SPHERE, examOptions));
      setCylinderList(getLabel(Code.Exam.Option.CYLINDER, examOptions));
      setAxisList(getLabel(Code.Exam.Option.AXIS, examOptions));
      setPrismList(getLabel(Code.Exam.Option.PRISM, examOptions));
      setOrientList(getLabel(Code.Exam.Option.ORIENT, examOptions));
      setAcuityList(getLabel(Code.Exam.Option.ACUITY, examOptions));
      setAddList(getLabel(Code.Exam.Option.ADD, examOptions));
    }
  }, [examOptions]);


  //suggested values for contact lens fields
  useEffect(() => {
    if (allOptions.length > 0) {
      setContactLensFittingStatus(getLabel(Code.Group.CONTACT_LENS_FITTING_STATUS, allOptions));
      setContactLensSupplier(getLabel(Code.Group.CONTACT_LENS_SUPPLIER, allOptions));
      setContactLensType(getLabel(Code.Group.CONTACT_LENS_TYPE, allOptions));
      setContactLensName(getLabel(Code.Group.CONTACT_LENS_NAME, allOptions));
      setContactLensColour(getLabel(Code.Group.CONTACT_LENS_COLOUR, allOptions));
      setContactLensSolution(getLabel(Code.Group.CONTACT_LENS_SOLUTION, allOptions));
    }
  }, [allOptions]);

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    if (formData) {
      const addonData = await API.Data.AddonData(formData, formName, keyId);
      const finalData = Utility.Sanitize.FormData({
        ...formData,
        ...addonData,
        saleitem_data: JSON.stringify(Utility.Clean.Object(inventoryData)),
      });
        
      const saveResult = await API.Data.Save(formName, keyId, finalData, setMessage, true, Code.Form.PopupClose.REMAINOPEN)
      const updateResult = await API.Data.updateSaleorder(finalData.saleorder_id, setMessage);

      //console.log("saveResult:",saveResult,"updateResult:",updateResult, "finalData:",finalData);

      if(saveResult && updateResult){
        Utility.Message.Info(["Item updated successfully"],setMessage);
        Utility.Button.PopupClose();
      }

      // const finalData = Utility.Sanitize.FormData({
      //   ...formData,
      //   inventory_data: JSON.stringify(Utility.Clean.Object(inventoryData)),
      // });

      // const localItemData = Utility.Get.ModelFields<Item>(finalData, itemKeys);
      // const localInventoryData = Utility.Get.ModelFields<Inventory>(finalData, inventoryKeys);

      // const itemId = formData.item_id?.toString();
      // const inventoryId = formData.inventory_id?.toString();

      // if(localItemData && localInventoryData && itemId && inventoryId){
      //   const response = await API.Data.SaveItemInventory(itemId, inventoryId, localItemData, localInventoryData);
      //   if(response){
      //     if(response['code']==200){
      //       Utility.Message.Info(["Item updated successfully"],setMessage);
      //       await Utility.Set.Delay(1000);
      //       Utility.Button.PopupClose();
      //     }
      //   }
      // }
    }
  };

  useEffect(()=>{ CalculateForward(); },[
    formData.saleitem_price,
    formData.saleitem_quantity,
    formData.saleitem_discount_percentage,
    formData.saleitem_discount_amount,
    formData.saleitem_tax1_percentage,
    formData.saleitem_tax1_amount
  ])

  const CalculatePrice = () => {
    const result = Utility.Calculate.Price(formData);
    if(result){
      setFormData((prevData) => ({
        ...prevData,
        saleitem_price: result.priceAmount, 
      }));
    }
    setShowMenu(false);
  }

  const CalculateDiscount = () => {
    const result = Utility.Calculate.Discount(formData);
    if(result){
      setFormData((prevData) => ({
        ...prevData,
        saleitem_discount_percentage: result.discountPercentage, 
        saleitem_discount_amount: result.discountAmount, 
      }));
    }
    setShowMenu(false);
  }

  const CalculateForward = () => {
    const result = Utility.Calculate.SaleItem(formData);
    if(result){
      const saleAmount = result.priceAmount * 2.4;
      setFormData((prevData) => ({
        ...prevData,
        saleprice: result.priceAmount,
        saleitem_quantity: result.quantity,
        saleitem_gross_amount: result.grossAmount,
        saleitem_taxable_amount: result.taxableAmount,
        saleitem_discount_percentage: result.discountPercentage,
        saleitem_discount_amount: result.discountAmount,
        saleitem_tax1_percentage: result.taxPercentage,
        saleitem_tax1_amount: result.taxAmount,
        saleitem_net_amount: result.netAmount,
        inventory_sale_price: saleAmount, 
        inventory_purchase_price: result.priceAmount, 
        inventory_cost_price: result.taxableAmount, 
      }));
    }
  }

  async function handleProductChange(product: OptionType | null ): Promise<void> {
    if (!product) return;

    if(keyId!==Code.Key.NEW) return;
    
    let specificationId = 2
    let productId = product.value;
    let productName = product.label;
    let productComment = '';
    let salePrice = 0;
    let discountPercent = 0;
    let discountAmount = 0;
    let taxPercent = 0;
    let quantity = 1;

    const productData = await API.Data.GetProductViewById<Product>(productId);
    if(productData){
      productName = productData.product_name || productName;
      productComment = productData.product_comment || '';
      salePrice = productData.product_sale_price || 0;
      discountPercent = productData.offer_percentage || 0;
      discountAmount = productData.offer_amount || 0;
      taxPercent = productData.tax_percentage || 0;
      quantity = productData.product_min_sale || 1;
      specificationId = productData.specification_id || 0;
    }
    else{ Utility.Message.Warning(["Product not found"],setMessage); return; }

    setFormData((prev: any) => ({
      ...prev,
      product_id: productId,
      product_name: productName,
      product_comment: productComment,
      saleitem_price: salePrice,
      saleitem_discount_percentage: discountPercent,
      saleitem_discount_amount: discountAmount,
      saleitem_tax1_percentage: taxPercent,
      specification_id: specificationId,
      saleitem_quantity: quantity,
    }));
  }

  useEffect(() => {
    const fetchSpecificationId = async () => {
      let pid =  formData.product_id;
      if(keyId===Code.Key.NEW && productId) { pid = Number(productId)}
      
      if (pid) {
        const specificationId = await API.Data.SpecificationId(Number(pid));
        if (!specificationId) return;

        setFormData((prev: any) => ({
          ...prev,
          specification_id: specificationId
        }));
      }
    };

    fetchSpecificationId();
  }, [formData.product_id]);

  //if opened item is exam, then it will give option, whether import exam list or not.
  useEffect(()=>{
    //console.log("sale--clientid---->",clientId)
    if(isImportExam){
        callExamList(clientId ? Number(clientId) : undefined);
        if(isExamType > 0 ){
          setTypeListOptions([]);
          Files.Json.Http(Code.File.EXAM+Code.File.TYPE+isExamType.toString(), Code.Option.Common.SELECT, setTypeListOptions, setError);
        }
    }
  },[isImportExam])

  //------------ get exam list of selected client.
  const callExamList = async (clientId: number | undefined) => {
    if (!clientId) return;  
    const url = API.Build.FormApiEndpint(Code.Form.Name.EXAM, 0, Name.Exam.Date, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([
        Name.Exam.Id,
        Name.Exam.Date, 
      ]),
      [Name.Client.Id]: clientId,
    });
    await API.Data.List<Exam>(url, setExamList, setError, setNoneLoading);
  };

  //------------set exam list to exam dropdown with default value.
  useEffect(() => {
    //console.log("examList:",examList);
    if(examList && examList.length){
      const examOptions: OptionType[] = Utility.Convert.AnyToOptions("exam_id", "exam_date", examList, Code.Option.Common.SELECT); 
      if(examOptions && examOptions.length){
          setExamListOptions(examOptions);
      }
    }
  }, [examList]); 

  const importExamData = async () =>{
    if(!examId || examId==0) { Utility.Message.Missing(["Select Exam"],setMessage); return; }
    if(!typeId || typeId==0) { Utility.Message.Missing(["Select Exam Type"],setMessage); return; }

    

    const exam = await API.Data.GetById<Exam>(Code.Form.Name.EXAM, examId.toString());

    console.clear(); //console.log("reached here-----exam-import",exam);

    if (exam) { 
      const data = exam.exam_data1;
      if(data){
        const examData = await Files.List.extractCommonData(data);
        if(examData){
          if(typeId==Code.Option.ExamType.FINALRX) mapFinalRx(examData);
          else if(typeId==Code.Option.ExamType.FINALRX2) mapFinalRx2(examData);
          else if(typeId==Code.Option.ExamType.FINALRX3) mapFinalRx3(examData);
          else if(typeId==Code.Option.ExamType.CLFINAL) mapCLFinal(examData);
          else if(typeId==Code.Option.ExamType.CLTRIAL1) mapCLTrial1(examData);
          else if(typeId==Code.Option.ExamType.CLTRIAL2) mapCLTrial2(examData);
          else if(typeId==Code.Option.ExamType.CLTRIAL3) mapCLTrial3(examData);
        }
      } 
    }
  }

  const mapFinalRx = (examData: CommonDataColumn) => {
    setInventoryData((prevData) => ({
      ...prevData,
      [EMF.FinalRx.Lens]: examData[EMF.FinalRx.Lens],
      [EMF.FinalRx.MatteTinted]: examData[EMF.FinalRx.MatteTinted],
      [EMF.FinalRx.ODSphere]: examData[EMF.FinalRx.ODSphere],
      [EMF.FinalRx.OSSphere]: examData[EMF.FinalRx.OSSphere],
      [EMF.FinalRx.ODCylinder]: examData[EMF.FinalRx.ODCylinder],
      [EMF.FinalRx.OSCylinder]:examData[EMF.FinalRx.OSCylinder],
      [EMF.FinalRx.ODAxis]: examData[EMF.FinalRx.ODAxis],
      [EMF.FinalRx.OSAxis]: examData[EMF.FinalRx.OSAxis],
      [EMF.FinalRx.ODAcuity]: examData[EMF.FinalRx.ODAcuity],
      [EMF.FinalRx.OSAcuity]: examData[EMF.FinalRx.OSAcuity],
      [EMF.FinalRx.ODAdd]: examData[EMF.FinalRx.ODAdd],
      [EMF.FinalRx.OSAdd]: examData[EMF.FinalRx.OSAdd],
      [EMF.FinalRx.ODPd]: examData[EMF.FinalRx.ODPd],
      [EMF.FinalRx.OSPd]: examData[EMF.FinalRx.OSPd],
      [EMF.FinalRx.OUAcuity]: examData[EMF.FinalRx.OUAcuity],
      [EMF.FinalRx.ODPrism]: examData[EMF.FinalRx.ODPrism],
      [EMF.FinalRx.OSPrism]: examData[EMF.FinalRx.OSPrism],
      [EMF.FinalRx.ODOrient]: examData[EMF.FinalRx.ODOrient],
      [EMF.FinalRx.OSOrient]: examData[EMF.FinalRx.OSOrient],
      [EMF.FinalRx.ODPrism2]: examData[EMF.FinalRx.ODPrism2],
      [EMF.FinalRx.OSPrism2]: examData[EMF.FinalRx.OSPrism2],
      [EMF.FinalRx.ODOrient2]: examData[EMF.FinalRx.ODOrient2],
      [EMF.FinalRx.OSOrient2]: examData[EMF.FinalRx.OSOrient2],
      [EMF.FinalRx.Method]: examData[EMF.FinalRx.Method],
      [EMF.FinalRx.Notes]: examData[EMF.FinalRx.Notes],
    }));
  };

  const mapFinalRx2 = (examData: CommonDataColumn) => {
    setInventoryData((prevData) => ({
      ...prevData,
      [EMF.FinalRx.Lens]: examData[EMF.FinalRx2.Lens],
      [EMF.FinalRx.MatteTinted]: examData[EMF.FinalRx2.MatteTinted],
      [EMF.FinalRx.ODSphere]: examData[EMF.FinalRx2.ODSphere],
      [EMF.FinalRx.OSSphere]: examData[EMF.FinalRx2.OSSphere],
      [EMF.FinalRx.ODCylinder]: examData[EMF.FinalRx2.ODCylinder],
      [EMF.FinalRx.OSCylinder]:examData[EMF.FinalRx2.OSCylinder],
      [EMF.FinalRx.ODAxis]: examData[EMF.FinalRx2.ODAxis],
      [EMF.FinalRx.OSAxis]: examData[EMF.FinalRx2.OSAxis],
      [EMF.FinalRx.ODAcuity]: examData[EMF.FinalRx2.ODAcuity],
      [EMF.FinalRx.OSAcuity]: examData[EMF.FinalRx2.OSAcuity],
      [EMF.FinalRx.ODAdd]: examData[EMF.FinalRx2.ODAdd],
      [EMF.FinalRx.OSAdd]: examData[EMF.FinalRx2.OSAdd],
      [EMF.FinalRx.ODPd]: examData[EMF.FinalRx2.ODPd],
      [EMF.FinalRx.OSPd]: examData[EMF.FinalRx2.OSPd],
      [EMF.FinalRx.OUAcuity]: examData[EMF.FinalRx2.OUAcuity],
      [EMF.FinalRx.ODPrism]: examData[EMF.FinalRx2.ODPrism],
      [EMF.FinalRx.OSPrism]: examData[EMF.FinalRx2.OSPrism],
      [EMF.FinalRx.ODOrient]: examData[EMF.FinalRx2.ODOrient],
      [EMF.FinalRx.OSOrient]: examData[EMF.FinalRx2.OSOrient],
      [EMF.FinalRx.ODPrism2]: examData[EMF.FinalRx2.ODPrism2],
      [EMF.FinalRx.OSPrism2]: examData[EMF.FinalRx2.OSPrism2],
      [EMF.FinalRx.ODOrient2]: examData[EMF.FinalRx2.ODOrient2],
      [EMF.FinalRx.OSOrient2]: examData[EMF.FinalRx2.OSOrient2],
      [EMF.FinalRx.Method]: examData[EMF.FinalRx2.Method],
      [EMF.FinalRx.Notes]: examData[EMF.FinalRx2.Notes],
    }));
  };

  const mapFinalRx3 = (examData: CommonDataColumn) => {
    setInventoryData((prevData) => ({
      ...prevData,
      [EMF.FinalRx.Lens]: examData[EMF.FinalRx3.Lens],
      [EMF.FinalRx.MatteTinted]: examData[EMF.FinalRx3.MatteTinted],
      [EMF.FinalRx.ODSphere]: examData[EMF.FinalRx3.ODSphere],
      [EMF.FinalRx.OSSphere]: examData[EMF.FinalRx3.OSSphere],
      [EMF.FinalRx.ODCylinder]: examData[EMF.FinalRx3.ODCylinder],
      [EMF.FinalRx.OSCylinder]:examData[EMF.FinalRx3.OSCylinder],
      [EMF.FinalRx.ODAxis]: examData[EMF.FinalRx3.ODAxis],
      [EMF.FinalRx.OSAxis]: examData[EMF.FinalRx3.OSAxis],
      [EMF.FinalRx.ODAcuity]: examData[EMF.FinalRx3.ODAcuity],
      [EMF.FinalRx.OSAcuity]: examData[EMF.FinalRx3.OSAcuity],
      [EMF.FinalRx.ODAdd]: examData[EMF.FinalRx3.ODAdd],
      [EMF.FinalRx.OSAdd]: examData[EMF.FinalRx3.OSAdd],
      [EMF.FinalRx.ODPd]: examData[EMF.FinalRx3.ODPd],
      [EMF.FinalRx.OSPd]: examData[EMF.FinalRx3.OSPd],
      [EMF.FinalRx.OUAcuity]: examData[EMF.FinalRx3.OUAcuity],
      [EMF.FinalRx.ODPrism]: examData[EMF.FinalRx3.ODPrism],
      [EMF.FinalRx.OSPrism]: examData[EMF.FinalRx3.OSPrism],
      [EMF.FinalRx.ODOrient]: examData[EMF.FinalRx3.ODOrient],
      [EMF.FinalRx.OSOrient]: examData[EMF.FinalRx3.OSOrient],
      [EMF.FinalRx.ODPrism2]: examData[EMF.FinalRx3.ODPrism2],
      [EMF.FinalRx.OSPrism2]: examData[EMF.FinalRx3.OSPrism2],
      [EMF.FinalRx.ODOrient2]: examData[EMF.FinalRx3.ODOrient2],
      [EMF.FinalRx.OSOrient2]: examData[EMF.FinalRx3.OSOrient2],
      [EMF.FinalRx.Method]: examData[EMF.FinalRx3.Method],
      [EMF.FinalRx.Notes]: examData[EMF.FinalRx3.Notes],
    }));
  };

  const mapCLTrial1 = (examData: CommonDataColumn) => {
    setInventoryData((prevData) => ({
      ...prevData,
      [EMF.CLFinal.ODSupplier]: examData[EMF.CLTrial1.ODSupplier],
      [EMF.CLFinal.OSSupplier]: examData[EMF.CLTrial1.OSSupplier],
      [EMF.CLFinal.ODType]: examData[EMF.CLTrial1.ODType],
      [EMF.CLFinal.OSType]:examData[EMF.CLTrial1.OSType],
      [EMF.CLFinal.ODName]: examData[EMF.CLTrial1.ODName],
      [EMF.CLFinal.OSName]: examData[EMF.CLTrial1.OSName],
      [EMF.CLFinal.ODColor]: examData[EMF.CLTrial1.ODColor],
      [EMF.CLFinal.OSColor]: examData[EMF.CLTrial1.OSColor],
      [EMF.CLFinal.ODBc]: examData[EMF.CLTrial1.ODBc],
      [EMF.CLFinal.OSBc]: examData[EMF.CLTrial1.OSBc],
      [EMF.CLFinal.ODDia]: examData[EMF.CLTrial1.ODDia],
      [EMF.CLFinal.OSDia]: examData[EMF.CLTrial1.OSDia],
      [EMF.CLFinal.ODSphere]: examData[EMF.CLTrial1.ODSphere],
      [EMF.CLFinal.OSSphere]: examData[EMF.CLTrial1.OSSphere],
      [EMF.CLFinal.ODCylinder]: examData[EMF.CLTrial1.ODCylinder],
      [EMF.CLFinal.OSCylinder]: examData[EMF.CLTrial1.OSCylinder],
      [EMF.CLFinal.ODAxis]: examData[EMF.CLTrial1.ODAxis],
      [EMF.CLFinal.OSAxis]: examData[EMF.CLTrial1.OSAxis],
      [EMF.CLFinal.ODAdd]: examData[EMF.CLTrial1.ODAdd],
      [EMF.CLFinal.OSAdd]: examData[EMF.CLTrial1.OSAdd],
      [EMF.CLFinal.FittingNote]: examData[EMF.CLTrial1.FittingNote],
      [EMF.CLFinal.Notes]: examData[EMF.CLTrial1.Notes],
      [EMF.CLFinal.Solution]: examData[EMF.CLTrial1.Solution],
    }));
  };

  const mapCLTrial2 = (examData: CommonDataColumn) => {
    setInventoryData((prevData) => ({
      ...prevData,
      [EMF.CLFinal.ODSupplier]: examData[EMF.CLTrial2.ODSupplier],
      [EMF.CLFinal.OSSupplier]: examData[EMF.CLTrial2.OSSupplier],
      [EMF.CLFinal.ODType]: examData[EMF.CLTrial2.ODType],
      [EMF.CLFinal.OSType]:examData[EMF.CLTrial2.OSType],
      [EMF.CLFinal.ODName]: examData[EMF.CLTrial2.ODName],
      [EMF.CLFinal.OSName]: examData[EMF.CLTrial2.OSName],
      [EMF.CLFinal.ODColor]: examData[EMF.CLTrial2.ODColor],
      [EMF.CLFinal.OSColor]: examData[EMF.CLTrial2.OSColor],
      [EMF.CLFinal.ODBc]: examData[EMF.CLTrial2.ODBc],
      [EMF.CLFinal.OSBc]: examData[EMF.CLTrial2.OSBc],
      [EMF.CLFinal.ODDia]: examData[EMF.CLTrial2.ODDia],
      [EMF.CLFinal.OSDia]: examData[EMF.CLTrial2.OSDia],
      [EMF.CLFinal.ODSphere]: examData[EMF.CLTrial2.ODSphere],
      [EMF.CLFinal.OSSphere]: examData[EMF.CLTrial2.OSSphere],
      [EMF.CLFinal.ODCylinder]: examData[EMF.CLTrial2.ODCylinder],
      [EMF.CLFinal.OSCylinder]: examData[EMF.CLTrial2.OSCylinder],
      [EMF.CLFinal.ODAxis]: examData[EMF.CLTrial2.ODAxis],
      [EMF.CLFinal.OSAxis]: examData[EMF.CLTrial2.OSAxis],
      [EMF.CLFinal.ODAdd]: examData[EMF.CLTrial2.ODAdd],
      [EMF.CLFinal.OSAdd]: examData[EMF.CLTrial2.OSAdd],
      [EMF.CLFinal.FittingNote]: examData[EMF.CLTrial2.FittingNote],
      [EMF.CLFinal.Notes]: examData[EMF.CLTrial2.Notes],
      [EMF.CLFinal.Solution]: examData[EMF.CLTrial2.Solution],
    }));
  };

  const mapCLTrial3 = (examData: CommonDataColumn) => {
    setInventoryData((prevData) => ({
      ...prevData,
      [EMF.CLFinal.ODSupplier]: examData[EMF.CLTrial3.ODSupplier],
      [EMF.CLFinal.OSSupplier]: examData[EMF.CLTrial3.OSSupplier],
      [EMF.CLFinal.ODType]: examData[EMF.CLTrial3.ODType],
      [EMF.CLFinal.OSType]:examData[EMF.CLTrial3.OSType],
      [EMF.CLFinal.ODName]: examData[EMF.CLTrial3.ODName],
      [EMF.CLFinal.OSName]: examData[EMF.CLTrial3.OSName],
      [EMF.CLFinal.ODColor]: examData[EMF.CLTrial3.ODColor],
      [EMF.CLFinal.OSColor]: examData[EMF.CLTrial3.OSColor],
      [EMF.CLFinal.ODBc]: examData[EMF.CLTrial3.ODBc],
      [EMF.CLFinal.OSBc]: examData[EMF.CLTrial3.OSBc],
      [EMF.CLFinal.ODDia]: examData[EMF.CLTrial3.ODDia],
      [EMF.CLFinal.OSDia]: examData[EMF.CLTrial3.OSDia],
      [EMF.CLFinal.ODSphere]: examData[EMF.CLTrial3.ODSphere],
      [EMF.CLFinal.OSSphere]: examData[EMF.CLTrial3.OSSphere],
      [EMF.CLFinal.ODCylinder]: examData[EMF.CLTrial3.ODCylinder],
      [EMF.CLFinal.OSCylinder]: examData[EMF.CLTrial3.OSCylinder],
      [EMF.CLFinal.ODAxis]: examData[EMF.CLTrial3.ODAxis],
      [EMF.CLFinal.OSAxis]: examData[EMF.CLTrial3.OSAxis],
      [EMF.CLFinal.ODAdd]: examData[EMF.CLTrial3.ODAdd],
      [EMF.CLFinal.OSAdd]: examData[EMF.CLTrial3.OSAdd],
      [EMF.CLFinal.FittingNote]: examData[EMF.CLTrial3.FittingNote],
      [EMF.CLFinal.Notes]: examData[EMF.CLTrial3.Notes],
      [EMF.CLFinal.Solution]: examData[EMF.CLTrial3.Solution],
    }));
  };

  const mapCLFinal = (examData: CommonDataColumn) => {
    setInventoryData((prevData) => ({
      ...prevData,
      [EMF.CLFinal.ODSupplier]: examData[EMF.CLFinal.ODSupplier],
      [EMF.CLFinal.OSSupplier]: examData[EMF.CLFinal.OSSupplier],
      [EMF.CLFinal.ODType]: examData[EMF.CLFinal.ODType],
      [EMF.CLFinal.OSType]:examData[EMF.CLFinal.OSType],
      [EMF.CLFinal.ODName]: examData[EMF.CLFinal.ODName],
      [EMF.CLFinal.OSName]: examData[EMF.CLFinal.OSName],
      [EMF.CLFinal.ODColor]: examData[EMF.CLFinal.ODColor],
      [EMF.CLFinal.OSColor]: examData[EMF.CLFinal.OSColor],
      [EMF.CLFinal.ODBc]: examData[EMF.CLFinal.ODBc],
      [EMF.CLFinal.OSBc]: examData[EMF.CLFinal.OSBc],
      [EMF.CLFinal.ODDia]: examData[EMF.CLFinal.ODDia],
      [EMF.CLFinal.OSDia]: examData[EMF.CLFinal.OSDia],
      [EMF.CLFinal.ODSphere]: examData[EMF.CLFinal.ODSphere],
      [EMF.CLFinal.OSSphere]: examData[EMF.CLFinal.OSSphere],
      [EMF.CLFinal.ODCylinder]: examData[EMF.CLFinal.ODCylinder],
      [EMF.CLFinal.OSCylinder]: examData[EMF.CLFinal.OSCylinder],
      [EMF.CLFinal.ODAxis]: examData[EMF.CLFinal.ODAxis],
      [EMF.CLFinal.OSAxis]: examData[EMF.CLFinal.OSAxis],
      [EMF.CLFinal.ODAdd]: examData[EMF.CLFinal.ODAdd],
      [EMF.CLFinal.OSAdd]: examData[EMF.CLFinal.OSAdd],
      [EMF.CLFinal.FittingNote]: examData[EMF.CLFinal.FittingNote],
      [EMF.CLFinal.Notes]: examData[EMF.CLFinal.Notes],
      [EMF.CLFinal.Solution]: examData[EMF.CLFinal.Solution],
    }));
  };

  const getInventoryList = async (searchKey: string) => {
    //console.log("getInventoryList:",searchKey)

    if (searchKey.length<=2) {
      setResults([]);
      return;
    } 
    try {
      const url =  `${Code.Path.SERVER}inventory?search=${searchKey}&fields=inventory_id,product_id,inventory_sale_price,inventory_utncode,inventory_skucode,inventory_data,specification_id`; 
      const result = await API.Data.GetAll(url);
      // const response = await fetch(`${Code.Path.SERVER}inventory?search=${searchKey}&fields=inventory_id,product_id,inventory_sale_price,inventory_utncode,inventory_skucode,inventory_data,specification_id`);
      // const result = await response.json();
      const data: Inventory[] = result.data;

      //console.log("Search Results:", data);

      if (Array.isArray(data)) {
        setResults(data);
      } else {
        setResults([]); 
      }

    } catch (error) {
      console.error('Error fetching search results:', error);
      setResults([]);  
    } 
  };
  
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    ////console.log("handleSearchChange---->");
    const value = event.target.value;
    setFormData((prevData) => ({
      ...prevData,
      saleitem_skucode: value, 
    }));
    setSearchKey(value);
    getInventoryList(value);
  };
  
  const handleInventoryClick = async (event: React.MouseEvent<HTMLLIElement>, Data: Inventory) => {
    let Value = '';
    if(Data.inventory_skucode && Data.inventory_skucode !='') Value = Data.inventory_skucode;
    else if(Data.inventory_utncode && Data.inventory_utncode !='') Value = Data.inventory_utncode;

    //console.log("Selected Data:", Data);

    setSearchKey(Value);
    const productName = await API.Data.GetProductName(Data.product_id);
    setFormData((prevData) => ({
      ...prevData,
      saleitem_skucode: Value, 
      saleitem_utncode: Data.inventory_utncode, 
      inventory_id: Data.inventory_id,
      product_id: Data.product_id,
      product_name: Utility.Value.Text(productName),
      saleitem_price: Data.inventory_sale_price,
      saleitem_quantity: 1,
    }));

    Files.List.ParseCommonData(Data.inventory_data, setInventoryData);

    if (!event.ctrlKey) {
      clearSearch(); // Hide the list only if the Control key is pressed
    }
  };

  const clearSearch = () => {
    setResults([]);
    setSearchKey('');
  }

useEffect(()=>{ 
  //console.log("formData changed:", formData);

 },[formData])

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} formName={formName} formId={formId} Privilege={Privilege} />
          <Control.Tab.Header titles={["Item Details"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Header id={Name.Product.Id} title={Title.Product} require={true}  size={[0,67,1]}>
                  <AsyncSelect id={Name.Product.Id} loadOptions={(inputValue) => API.Data.AsyncOption(inputValue, Code.Form.Name.PRODUCT, Code.Mapping.product.value, Code.Mapping.product.label)} styles={Code.Style.FormOption} onChange={(selected: OptionType | null) => handleProductChange(selected)} value={Utility.Value.Async(formData.product_id,formData.product_name)} placeholder="Search" isDisabled={false} />
                </Field.Header>
                <Field.Date id={Name.SaleItem.Date} value={formData.saleitem_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,33,0]} require={true} currentDate={true} />
              </Control.Row>
              <Control.Row>
                <Field.Text id={Name.SaleItem.Skucode} value={formData.saleitem_skucode} title={Title.SkuUtn} onChange={(e) => handleSearchChange(e)} size={[0,66,1]} disabled={isSKUDisable} placeholder={isSKUDisable ? 'Not Require' :''} />
                <Field.Select id={Name.Common.TypeId} value={formData.type_id} title={Title.Type} options={typeOptions} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,0]} require={true} />
              </Control.Row>
              <Control.Row>
                {results.length > 0 && (
                  <div className='searchlist'>
                    <a onClick={() => clearSearch()}>×</a>
                    <ul>
                      <li className='fwb'>
                        <span className='form-col20'>UTN</span>
                        <span className='form-col30'>Brand</span>
                        <span className='form-col30'>Model</span>
                        <span className='form-col20'>SKU</span>
                      </li>
                      {results.map(result => (
                        <li key={result.inventory_id} onClick={(event) => handleInventoryClick(event, result)}>
                          <span className='form-col20'>{result.inventory_utncode}</span>
                          <span className='form-col30'>{Utility.Get.InvDataValue(result.inventory_data,result.specification_id,InventoryColumn.BRAND)}</span>
                          <span className='form-col30'>{Utility.Get.InvDataValue(result.inventory_data,result.specification_id,InventoryColumn.MODEL)}</span>
                          <span className='form-col20'>{result.inventory_skucode}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </Control.Row>
              <Control.Row>
                <Field.Amount id={Name.SaleItem.Price} value={formData.saleitem_price} title={Title.Price} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,33,1]} require={true} />
                <Field.Number id={Name.SaleItem.Quantity} value={formData.saleitem_quantity} title={Title.Quantity} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,33,1]} require={true} minValue={-100} align={Code.Align.RIGHT} />
                <Field.Amount id={Name.SaleItem.NetAmount} value={formData.saleitem_net_amount} title={Title.NetAmount} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,33,0]} require={true} />
              </Control.Row>
              <Control.Row>
                <Field.Number id={Name.SaleItem.DiscountPercentage} value={formData.saleitem_discount_percentage} title={Title.DiscountP} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,24,1]} align={Code.Align.RIGHT} />
                <Field.Amount id={Name.SaleItem.DiscountAmount} value={formData.saleitem_discount_amount} title={Title.Discount} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,26,1]} />
                <Field.Number id={Name.SaleItem.Tax1Percentage} value={formData.saleitem_tax1_percentage} title={Title.GSTP} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,26,1]} align={Code.Align.RIGHT} />
                <Field.Amount id={Name.SaleItem.Tax1Amount} value={formData.saleitem_tax1_amount} title={Title.GST} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,24,0]} />
              </Control.Row>
                {showImportExam && (
                <Control.Row>
                  <Field.CheckSingle isChecked={isImportExam} title={"Import Exam"} setIsChecked={setIsImportExam} horizontal={true} />
                </Control.Row>
              )}
              {isImportExam && (
                <Control.Row>
                  <Field.Select id={Name.Exam.Id} value={examId} title={"Exam Date"} options={examListOptions} onChange={(e) => setExamId(e.target.value)} size={[0,50,1]} />
                  <Field.Select id={Name.Common.TypeId} value={typeId} title={"Type"} options={typeListOptions} onChange={(e) => setTypeId(e.target.value)} size={[1,25,2]} />
                  <Control.ButtonColumn size={[25,6,0,0,0]} align={Code.Align.LEFT}>
                    <Button.Action title={'Import'} info={"Import prescription of the exam"} onClick={importExamData} visible={true} />
                  </Control.ButtonColumn>
                </Control.Row>
              )}
              {isExam && (
                <>
                  <Field.ContainerHeader title={specTitle} className='mt2' />
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='Lens' />
                    <Field.Suggestion id={EMF.FinalRx.Lens} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.Lens as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,30,0]} dataList={lensTypeList} />
                    <Field.Title size={[0,30,0]} title='Matte/Tinted' align={Code.Align.RIGHT} />
                    <Field.Suggestion id={EMF.FinalRx.MatteTinted} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.MatteTinted as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,30,0]} dataList={tintedList} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} />
                    <Field.Title size={[0,19,0]} title='Sphere' align={Code.Align.CENTER} />
                    <Field.Title size={[0,19,0]} title='Cylinder' align={Code.Align.CENTER} />
                    <Field.Title size={[0,19,0]} title='Axis' align={Code.Align.CENTER} />
                    <Field.Title size={[0,19,0]} title='Acuity' align={Code.Align.CENTER} />
                    <Field.Title size={[0,19,0]} title='Add' align={Code.Align.CENTER} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='OD' />
                    <Field.Suggestion id={EMF.FinalRx.ODSphere} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODSphere as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} dataList={sphereList} />
                    <Field.Suggestion id={EMF.FinalRx.ODCylinder} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODCylinder as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} dataList={cylinderList} />
                    <Field.Suggestion id={EMF.FinalRx.ODAxis} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODAxis as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} dataList={axisList} />
                    <Field.Suggestion id={EMF.FinalRx.ODAcuity} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODAcuity as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} dataList={acuityList} />
                    <Field.Suggestion id={EMF.FinalRx.ODAdd} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODAdd as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} dataList={addList} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='OS' />
                    <Field.Suggestion id={EMF.FinalRx.OSSphere} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSSphere as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} dataList={sphereList} />
                    <Field.Suggestion id={EMF.FinalRx.OSCylinder} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSCylinder as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} dataList={cylinderList} />
                    <Field.Suggestion id={EMF.FinalRx.OSAxis} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSAxis as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} dataList={axisList} />
                    <Field.Suggestion id={EMF.FinalRx.OSAcuity} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSAcuity as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} dataList={acuityList} />
                    <Field.Suggestion id={EMF.FinalRx.OSAdd} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSAdd as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} dataList={addList} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} />
                    <Field.Title size={[0,19,0]} title='PD' align={Code.Align.CENTER} />
                    <Field.Title size={[0,19,0]} title='NPD' align={Code.Align.CENTER} />
                    <Field.Title size={[0,19,0]} title='WD' align={Code.Align.CENTER} />
                    <Field.Title size={[0,19,0]} title='Height' align={Code.Align.CENTER} />
                    <Field.Title size={[0,19,0]} title='BC' align={Code.Align.CENTER} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='OD' />
                    <Field.Text id={EMF.OrderRx.ODPD} value={Utility.Get.FieldValue(inventoryData, EMF.OrderRx.ODPD as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} />
                    <Field.Text id={EMF.OrderRx.ODNPD} value={Utility.Get.FieldValue(inventoryData, EMF.OrderRx.ODNPD as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} />
                    <Field.Text id={EMF.OrderRx.ODWD} value={Utility.Get.FieldValue(inventoryData, EMF.OrderRx.ODWD as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} />
                    <Field.Text id={EMF.OrderRx.ODHeight} value={Utility.Get.FieldValue(inventoryData, EMF.OrderRx.ODHeight as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} />
                    <Field.Text id={EMF.OrderRx.ODBC} value={Utility.Get.FieldValue(inventoryData, EMF.OrderRx.ODBC as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='OS' />
                    <Field.Text id={EMF.OrderRx.OSPD} value={Utility.Get.FieldValue(inventoryData, EMF.OrderRx.OSPD as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} />
                    <Field.Text id={EMF.OrderRx.OSNPD} value={Utility.Get.FieldValue(inventoryData, EMF.OrderRx.OSNPD as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} />
                    <Field.Text id={EMF.OrderRx.OSWD} value={Utility.Get.FieldValue(inventoryData, EMF.OrderRx.OSWD as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} />
                    <Field.Text id={EMF.OrderRx.OSHeight} value={Utility.Get.FieldValue(inventoryData, EMF.OrderRx.OSHeight as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} />
                    <Field.Text id={EMF.OrderRx.OSBC} value={Utility.Get.FieldValue(inventoryData, EMF.OrderRx.OSBC as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,19,0]} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='Method' />
                    <Field.Text id={EMF.FinalRx.Method} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.Method as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,61,0]} />
                    <Field.Title size={[0,12,1]} title='OU' align={Code.Align.RIGHT} />
                    <Field.Suggestion id={EMF.FinalRx.OUAcuity} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OUAcuity as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,17,0]} dataList={acuityList} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='Notes' />
                    <Field.Text id={EMF.FinalRx.Notes} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.Notes as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,90,0]} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='Date' />
                    <Field.Text id={EMF.FinalRx.RxDate} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.RxDate as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,30,0]} placeholder='Rx' />
                    <Field.Title size={[0,30,0]} title='Expiry Date' align={Code.Align.RIGHT} />
                    <Field.Text id={EMF.FinalRx.RxExpiry} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.RxExpiry as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,30,0]} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} />
                    <Field.Title size={[0,20,0]} title='Prism' align={Code.Align.CENTER} />
                    <Field.Title size={[0,20,0]} title='Orient' align={Code.Align.CENTER} />
                    <Field.Title size={[0,10,0]} />
                    <Field.Title size={[0,20,0]} title='Prism 2' align={Code.Align.CENTER} />
                    <Field.Title size={[0,20,0]} title='Orient 2' align={Code.Align.CENTER} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='OD' />
                    <Field.Suggestion id={EMF.FinalRx.ODPrism} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODPrism as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={prismList}  />
                    <Field.Suggestion id={EMF.FinalRx.ODOrient} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODOrient as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={orientList}  />
                    <Field.Title size={[0,10,0]} title='OD' align={Code.Align.RIGHT} />
                    <Field.Suggestion id={EMF.FinalRx.ODPrism2} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODPrism2 as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={prismList}  />
                    <Field.Suggestion id={EMF.FinalRx.ODOrient2} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODOrient2 as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={orientList} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='OS' />
                    <Field.Suggestion id={EMF.FinalRx.OSPrism} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSPrism as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={prismList}  />
                    <Field.Suggestion id={EMF.FinalRx.OSOrient} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSOrient as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={orientList} />
                    <Field.Title size={[0,10,0]} title='OS' align={Code.Align.RIGHT} />
                    <Field.Suggestion id={EMF.FinalRx.OSPrism2} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSPrism2 as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={prismList}  />
                    <Field.Suggestion id={EMF.FinalRx.OSOrient2} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSOrient2 as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={orientList} />
                  </Control.Flex>
                </>
              )}
              {/* {isExam && (
                <>
                  <Field.ContainerHeader title={specTitle} className='mt2' />
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='Lens' />
                    <Field.Suggestion id={EMF.FinalRx.Lens} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.Lens as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,30,0]} dataList={lensTypeList} />
                    <Field.Title size={[0,30,0]} title='Matte/Tinted' align={Code.Align.RIGHT} />
                    <Field.Suggestion id={EMF.FinalRx.MatteTinted} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.MatteTinted as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,30,0]} dataList={tintedList} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} />
                    <Field.Title size={[0,15,0]} title='Sphere' align={Code.Align.CENTER} />
                    <Field.Title size={[0,15,0]} title='Cylinder' align={Code.Align.CENTER} />
                    <Field.Title size={[0,15,0]} title='Axis' align={Code.Align.CENTER} />
                    <Field.Title size={[0,18,0]} title='Add' align={Code.Align.CENTER} />
                    <Field.Title size={[0,12,0]} title='PD' align={Code.Align.CENTER} />
                    <Field.Title size={[0,15,0]} title='Acuity' align={Code.Align.CENTER} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='OD' />
                    <Field.Suggestion id={EMF.FinalRx.ODSphere} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODSphere as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} dataList={sphereList} />
                    <Field.Suggestion id={EMF.FinalRx.ODCylinder} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODCylinder as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} dataList={cylinderList} />
                    <Field.Suggestion id={EMF.FinalRx.ODAxis} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODAxis as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} dataList={axisList} />
                    <Field.Suggestion id={EMF.FinalRx.ODAdd} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODAdd as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,16,0]} dataList={addList} />
                    <Field.Text id={EMF.FinalRx.ODPd} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODPd as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,12,0]} />
                    <Field.Suggestion id={EMF.FinalRx.ODAcuity} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODAcuity as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,17,0]} dataList={acuityList} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='OS' />
                    <Field.Suggestion id={EMF.FinalRx.OSSphere} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSSphere as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} dataList={sphereList} />
                    <Field.Suggestion id={EMF.FinalRx.OSCylinder} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSCylinder as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} dataList={cylinderList} />
                    <Field.Suggestion id={EMF.FinalRx.OSAxis} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSAxis as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} dataList={axisList} />
                    <Field.Suggestion id={EMF.FinalRx.OSAdd} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSAdd as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,16,0]} dataList={addList} />
                    <Field.Text id={EMF.FinalRx.OSPd} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSPd as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,12,0]} />
                    <Field.Suggestion id={EMF.FinalRx.OSAcuity} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSAcuity as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,17,0]} dataList={acuityList} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='Method' />
                    <Field.Text id={EMF.FinalRx.Method} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.Method as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,61,0]} />
                    <Field.Title size={[0,12,1]} title='OU' align={Code.Align.RIGHT} />
                    <Field.Suggestion id={EMF.FinalRx.OUAcuity} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OUAcuity as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,17,0]} dataList={acuityList} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='Notes' />
                    <Field.Text id={EMF.FinalRx.Notes} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.Notes as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,90,0]} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='Date' />
                    <Field.Text id={EMF.FinalRx.RxDate} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.RxDate as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,30,0]} placeholder='Rx' />
                    <Field.Title size={[0,30,0]} title='Expiry Date' align={Code.Align.RIGHT} />
                    <Field.Text id={EMF.FinalRx.RxExpiry} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.RxExpiry as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,30,0]} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} />
                    <Field.Title size={[0,20,0]} title='Prism' align={Code.Align.CENTER} />
                    <Field.Title size={[0,20,0]} title='Orient' align={Code.Align.CENTER} />
                    <Field.Title size={[0,10,0]} />
                    <Field.Title size={[0,20,0]} title='Prism 2' align={Code.Align.CENTER} />
                    <Field.Title size={[0,20,0]} title='Orient 2' align={Code.Align.CENTER} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='OD' />
                    <Field.Suggestion id={EMF.FinalRx.ODPrism} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODPrism as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={prismList}  />
                    <Field.Suggestion id={EMF.FinalRx.ODOrient} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODOrient as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={orientList}  />
                    <Field.Title size={[0,10,0]} title='OD' align={Code.Align.RIGHT} />
                    <Field.Suggestion id={EMF.FinalRx.ODPrism2} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODPrism2 as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={prismList}  />
                    <Field.Suggestion id={EMF.FinalRx.ODOrient2} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.ODOrient2 as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={orientList} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='OS' />
                    <Field.Suggestion id={EMF.FinalRx.OSPrism} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSPrism as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={prismList}  />
                    <Field.Suggestion id={EMF.FinalRx.OSOrient} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSOrient as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={orientList} />
                    <Field.Title size={[0,10,0]} title='OS' align={Code.Align.RIGHT} />
                    <Field.Suggestion id={EMF.FinalRx.OSPrism2} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSPrism2 as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={prismList}  />
                    <Field.Suggestion id={EMF.FinalRx.OSOrient2} value={Utility.Get.FieldValue(inventoryData, EMF.FinalRx.OSOrient2 as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={orientList} />
                  </Control.Flex>
                </>
              )} */}
              {isCLens && (
                <>
                  <Field.ContainerHeader title={specTitle} className='mt2' />
                  <Control.Flex>
                    <Field.Title size={[0,65,2]} title='CL Fitting Status' align={Code.Align.RIGHT} />
                    <Field.Suggestion id={EMF.CLFinal.Status} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.Status as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[0,35,0]} dataList={contactLensFittingStatus} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} />
                    <Field.Title size={[0,20,0]} title='Supplier' align={Code.Align.CENTER}/>
                    <Field.Title size={[0,20,0]} title='Lens Type' align={Code.Align.CENTER}/>
                    <Field.Title size={[0,20,0]} title='Lens Name' align={Code.Align.CENTER}/>
                    <Field.Title size={[0,20,0]} title='Colour' align={Code.Align.CENTER}/>
                    <Field.Title size={[0,10,0]} title='Pack' align={Code.Align.CENTER}/>
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='OD' />
                    <Field.Suggestion id={EMF.CLFinal.ODSupplier} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.ODSupplier as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={contactLensSupplier} />
                    <Field.Suggestion id={EMF.CLFinal.ODType} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.ODType as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={contactLensType} />
                    <Field.Suggestion id={EMF.CLFinal.ODName} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.ODName as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={contactLensName} />
                    <Field.Suggestion id={EMF.CLFinal.ODColor} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.ODColor as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={contactLensColour} />
                    <Field.Suggestion id={EMF.CLFinal.ODPack} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.ODPack as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,10,0]} className='px0' />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='OS' />
                    <Field.Suggestion id={EMF.CLFinal.OSSupplier} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.OSSupplier as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={contactLensSupplier} />
                    <Field.Suggestion id={EMF.CLFinal.OSType} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.OSType as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={contactLensType} />
                    <Field.Suggestion id={EMF.CLFinal.OSName} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.OSName as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={contactLensName} />
                    <Field.Suggestion id={EMF.CLFinal.OSColor} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.OSColor as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,20,0]} dataList={contactLensColour} />
                    <Field.Suggestion id={EMF.CLFinal.OSPack} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.OSPack as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,10,0]} className='px0' />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} />
                    <Field.Title size={[0,15,0]} title='BC' align={Code.Align.CENTER}/>
                    <Field.Title size={[0,15,0]} title='Dia' align={Code.Align.CENTER}/>
                    <Field.Title size={[0,15,0]} title='Sphere' align={Code.Align.CENTER}/>
                    <Field.Title size={[0,15,0]} title='Cylinder' align={Code.Align.CENTER}/>
                    <Field.Title size={[0,15,0]} title='Axis' align={Code.Align.CENTER}/>
                    <Field.Title size={[0,15,0]} title='Add' align={Code.Align.CENTER}/>
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='OD' />
                    <Field.Text id={EMF.CLFinal.ODBc} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.ODBc as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} />
                    <Field.Text id={EMF.CLFinal.ODDia} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.ODDia as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} />
                    <Field.Suggestion id={EMF.CLFinal.ODSphere} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.ODSphere as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} dataList={sphereList} />
                    <Field.Suggestion id={EMF.CLFinal.ODCylinder} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.ODCylinder as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} dataList={cylinderList} />
                    <Field.Suggestion id={EMF.CLFinal.ODAxis} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.ODAxis as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} dataList={axisList} />
                    <Field.Suggestion id={EMF.CLFinal.ODAdd} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.ODAdd as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} dataList={addList} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,10,0]} title='OS' />
                    <Field.Text id={EMF.CLFinal.OSBc} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.OSBc as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} />
                    <Field.Text id={EMF.CLFinal.OSDia} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.OSDia as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} />
                    <Field.Suggestion id={EMF.CLFinal.OSSphere} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.OSSphere as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} dataList={sphereList} />
                    <Field.Suggestion id={EMF.CLFinal.OSCylinder} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.OSCylinder as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} dataList={cylinderList} />
                    <Field.Suggestion id={EMF.CLFinal.OSAxis} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.OSAxis as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} dataList={axisList} />
                    <Field.Suggestion id={EMF.CLFinal.OSAdd} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.OSAdd as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[1,15,0]} dataList={addList} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,65,2]} title='Expiry Date' align={Code.Align.RIGHT} />
                    <Field.Text id={EMF.CLFinal.ExpiryDate} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.ExpiryDate as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[0,35,0]} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,25,2]} title='Fitting Notes' />
                    <Field.Text id={EMF.CLFinal.FittingNote} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.FittingNote as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[0,75,0]} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,25,2]} title='Notes for Dispenser' />
                    <Field.Text id={EMF.CLFinal.Notes} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.Notes as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[0,75,0]} />
                  </Control.Flex>
                  <Control.Flex>
                    <Field.Title size={[0,25,2]} title='Solution' />
                    <Field.Suggestion id={EMF.CLFinal.Solution} value={Utility.Get.FieldValue(inventoryData, EMF.CLFinal.Solution as keyof CommonDataColumn)} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)} size={[0,75,0]} dataList={contactLensSolution} />
                  </Control.Flex>
                </>
              )}
              {isSpec && controlOptions.length == 12 && (
                <>
                  <Field.ContainerHeader title={specTitle} className='mt2' />
                  <Control.Flex>
                    <Control.Column size={[0,50,1,1]}>
                      <Control.Box className='mt2'>
                        {controlOptions.slice(0, 6).map((item, index) => (
                          <Field.Suggestion key={item.value ?? index} id={`D${item.value}`} value={Utility.Get.FieldValue(inventoryData, `D${item.value}` as keyof CommonDataColumn)} title={item.label} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)}  dataList={item.data1} horizontal={true} className='htext2' width={70} />
                        ))}
                      </Control.Box>
                    </Control.Column>
                    <Control.Column size={[1,50,0,2]}>
                      <Control.Box className='mt2'>
                        {controlOptions.slice(6).map((item, index) => (
                          <Field.Suggestion key={item.value ?? index} id={`D${item.value}`} value={Utility.Get.FieldValue(inventoryData, `D${item.value}` as keyof CommonDataColumn)} title={item.label} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)}  dataList={item.data1} horizontal={true} className='htext2' width={70} />
                        ))}
                      </Control.Box>
                    </Control.Column>
                  </Control.Flex>
                </>
              ) }
              {isSpec && controlOptions.length !== 12 && (
                <>
                  <Field.ContainerHeader title={specTitle} className='mt2' />
                  <Control.Box className='mt2'>
                    {controlOptions.map((item, index) => (
                      <Field.Suggestion key={item.value ?? index} id={`D${item.value}`} value={Utility.Get.FieldValue(inventoryData, `D${item.value}` as keyof CommonDataColumn)} title={item.label} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)}  dataList={item.data1} horizontal={true} className='htext2' width={80} />
                    ))}
                  </Control.Box>
                </>
              ) }
              {/* {isSpec && controlOptions.length > 0 && (
                <>
                  <Field.ContainerHeader title={specTitle} className='mt2' />
                  <Control.Box className='mt2'>
                    {controlOptions.map((item, index) => (
                      <Field.Suggestion key={item.value ?? index} id={`D${item.value}`} value={Utility.Get.FieldValue(inventoryData, `D${item.value}` as keyof CommonDataColumn)} title={item.label} onChange={(e) => Form.MultiValue.Change(e, inventoryData, setInventoryData)}  dataList={item.data1} horizontal={true} className='htext2' width={80} />
                    ))}
                  </Control.Box>
                </>
              ) } */}
             
             <Control.Row>
                <Field.Area id={Name.SaleItem.Comment} value={formData.saleitem_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Row>
            </Control.Tab.Content>

          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}>
        <Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition}>
          <li className="more">
            <a className="icon-calculate">Calculate</a>
            <ul>
                <li><a onClick={() => CalculatePrice()} title='Calculate price'>Price</a></li>
                <li><a onClick={() => CalculateDiscount()} title='Calculate discount'>Discount</a></li>
            </ul>
          </li>
        </Control.FormContextMenu>
      </div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default SaleItemForm;